import { cn } from '../../lib/cn.ts';

export interface LanguagePillProps {
  /** Uppercase language code, e.g. "EN", "DE". */
  code: string;
  active?: boolean;
  className?: string;
  'data-testid'?: string;
}

/** LanguagePill — a printed language-code chip; active codes invert to charcoal. */
export function LanguagePill({
  code,
  active = false,
  className,
  'data-testid': testId,
}: LanguagePillProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        'inline-flex items-center justify-center rounded-md px-1.5 py-0.5',
        'font-[var(--font-mono)] text-[11px] font-medium',
        active
          ? 'bg-[var(--color-charcoal)] text-[var(--color-alabaster)]'
          : 'bg-[var(--color-stone-100)] text-[var(--color-stone-mid)]',
        className,
      )}
    >
      {code}
    </span>
  );
}
